import * as Sentry from "@sentry/react";
import { sentryDsn, appEnv } from "./env";

/**
 * Initialise Sentry error monitoring — only when a DSN is configured.
 *
 * The DSN is optional by design: a build without REACT_APP_SENTRY_DSN must run
 * exactly as it did before Sentry existed. No init, no network calls, just one
 * console warning so a missing key is visible in devtools rather than silent.
 */
export const initSentry = () => {
  if (!sentryDsn) {
    console.warn("Sentry key is missing — error monitoring is disabled.");
    return;
  }

  Sentry.init({
    dsn: sentryDsn,
    environment: appEnv,
    integrations: [Sentry.browserTracingIntegration()],
    // Keep tracing cheap in production; errors themselves are always captured.
    tracesSampleRate: 0.2,
    // Third-party browser extensions raise noise unrelated to the app.
    ignoreErrors: ["ResizeObserver loop limit exceeded"],
  });
};
